import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import axios from "axios";
import { apiRoot } from "../../index";

export default function BillingConfig() {
  const { userInfos } = useContext(UserContext);
  const [isFetching, setIsFetching] = useState(false);
  const [billing, setBilling] = useState({
    defaultDaysUntilDue: 30,
  });

  useEffect(() => {
    if (userInfos?.billing) {
      setBilling(userInfos.billing);
    }
  }, [userInfos.billing]);

  const handleBillingChange = (e) => {
    let { name, value } = e.target;
    if (name === "defaultDaysUntilDue") value = parseInt(value) || 30;
    setBilling((old) => ({
      ...old,
      [name]: value,
    }));
  };

  async function handleBillingFormSubmit(e) {
    e.preventDefault();
    setIsFetching(true);

    try {
      await axios.post(
        apiRoot + "/api/v1/update-billing",
        billing,
        {
          headers: {
            authorization: userInfos.jwt,
          },
        }
      );

      window.alert("Paramètres de facturation mis à jour avec succès");
    } catch (e) {
      console.error(e);
      window.alert("Une erreur est survenue");
    }

    setIsFetching(false);
  }

  const buttonText = (disabled = false) =>
    isFetching === true ? (
      <button type="submit" className="btn btn-primary" disabled>
        Mise à jour...
      </button>
    ) : (
      <button type="submit" className="btn btn-primary" disabled={disabled}>
        Mettre à jour
      </button>
    );

  return (
    <form onSubmit={handleBillingFormSubmit} className="kt-form">
      <div className="kt-portlet__body">
        <div className="kt-section kt-section--first">
          <div className="kt-section__body">
            <div className="form-group row">
              <label className="col-lg-3 col-form-label">
                Jours avant échéance par défaut:
              </label>
              <div className="col-lg-6">
                <input
                  type="number"
                  step="1"
                  min="1"
                  className="form-control"
                  name="defaultDaysUntilDue"
                  value={billing.defaultDaysUntilDue}
                  onChange={handleBillingChange}
                  disabled={userInfos.createdBy}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="kt-portlet__foot">
        {!userInfos.createdBy && (
          <div className="kt-form__actions">{buttonText()}</div>
        )}
      </div>
    </form>
  );
}